/**
 * Shared dashboard shell primitives (Ant + styled-components).
 * Reused by Experiment dashboard, Lead Pulse, and Leads intelligence header.
 */

import styled from "styled-components";
import { Card } from "antd";

export const ShellSection = styled.div`
  margin-bottom: 24px;
`;

export const SlotCard = styled(Card)`
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  height: 100%;

  .ant-card-head {
    min-height: auto;
    padding: 0 24px;
  }

  .ant-card-head-title {
    color: #005249;
    font-weight: 700;
    padding: 16px 0;
  }

  .ant-card-body {
    padding: 16px 24px 24px;
  }
`;

export const MetricTile = styled.div`
  border: 1px solid #e6efed;
  border-radius: 12px;
  padding: 12px 14px;
  background: #fff;
  min-height: 88px;

  .metric-label {
    display: block;
    font-size: 12px;
    color: #5f6b6a;
    margin-bottom: 6px;
  }

  .metric-value {
    display: block;
    font-size: 22px;
    font-weight: 700;
    color: #005249;
    line-height: 1.2;
  }

  .metric-hint {
    display: block;
    margin-top: 4px;
    font-size: 11px;
    color: #8aa8a3;
  }
`;

export const SectionEyebrow = styled.div`
  font-size: 11px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #8aa8a3;
  margin-bottom: 10px;
  font-weight: 600;
`;

export function formatMoneyZar(amount) {
  if (amount == null || !Number.isFinite(Number(amount))) return "—";
  return `R${Number(amount).toLocaleString("en-ZA", {
    maximumFractionDigits: 0,
  })}`;
}

export function formatPercent(value) {
  if (value == null || !Number.isFinite(Number(value))) return "—";
  const n = Number(value);
  const pct = n <= 1 ? n * 100 : n;
  return `${pct.toFixed(0)}%`;
}
